import React, { useEffect } from 'react';
import { SideMenu } from 'features/account-settings/components/coordinator-dashboard/SideMenu';
import { DashboardContent } from 'features/account-settings/components/coordinator-dashboard/DashboardContent';
import { useRootSelector, FeaturesState } from 'common/features/featuresReducer';
import { OrganizationMembership } from 'common/api/crm/models/OrganizationMembership';
import Skeleton from 'react-loading-skeleton';
import { useApi } from 'common/modules/async-actions/useApi';
import { getOrganizationDetail } from 'common/api/crm/organization/service';
import { selectDefaultOrganization } from 'common/features/store/duck/home/duck';
import { Switch, Route } from 'react-router-dom';
import { Routes } from 'routes';
import { OrganizationSettings } from './OrganizationSettings';

const isScripWareOrg = (
    orgId: string,
    organizations?: Record<string, OrganizationMembership>
): [boolean, OrganizationMembership | null] => {
    if (!organizations || !orgId) {
        return [false, null];
    }

    const org = organizations[orgId];
    return [org.organization.isScripWareOrg, org];
};

export const CoordinatorDashboard = () => {
    const defaultOrganization = useRootSelector(selectDefaultOrganization);
    const selectedOrganizationId = defaultOrganization?.id as string;

    const organizations = useRootSelector(
        (state: FeaturesState) => state.store.home.homeDetails?.organizations
    );
    const [isScripWare] = isScripWareOrg(selectedOrganizationId, organizations);
    const [loadOrgDetailData, , orgDetailRes] = useApi(getOrganizationDetail);

    useEffect(() => {
        if (selectedOrganizationId) {
            loadOrgDetailData(selectedOrganizationId);
        }
    }, [selectedOrganizationId, loadOrgDetailData]);

    // CASE: page still loading -- we shouldn't render coordinator dashboard
    if (!selectedOrganizationId) {
        return <Skeleton height={100} />;
    }

    return (
        <div className="flex flex-col md:flex-row gap-4">
            <SideMenu
                showScripWareBtn={isScripWare}
                organizationInfo={orgDetailRes?.data || undefined}
            />
            <Switch>
                <Route path={Routes.ShopAccountSettingsCoordinatorTab} exact>
                    <DashboardContent isScripWare={isScripWare} />
                </Route>
                <Route path={Routes.ShopAccountSettingsCoordinatorOrganizationSettings}>
                    <OrganizationSettings selectedOrganizationId={selectedOrganizationId} />
                </Route>
            </Switch>
        </div>
    );
};
